import React from 'react';
import { ToastContainer } from 'react-toastify';
import OrderPage from '../components/OrderPage';

const OrderPageApp = (props) => (
  <>
    <OrderPage {...props} />
    <ToastContainer icon={false} />
  </>
);

export default OrderPageApp;
